module.exports = __webpack_public_path__ + "static/coding-d1725808578a6f2dae4f2938b57c3709.jpg";